import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from './app.service';
import { FeatureFlagsService } from './feature-flag.services';
import {IviMy23SharedService} from'./ivi-my23/ivi-my23-shared.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private _appService: AppService,
    private router: Router,
    private featureFlags: FeatureFlagsService,
    private ivimy23Service:  IviMy23SharedService
  ) { }


  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
      if(state.url.includes('ivi/my23') && !this.featureFlags.isEnabled('iviTokenFlag')){
        this.router.navigate(['/not-found']);
        return false;
      }
    
    let res = await this._appService.GetSession().toPromise().catch(() => null)
    if (!res) {
      return this.router.createUrlTree(['/not-found']);
    }
    if(res.programName === 'IVIMY23'){
      this.ivimy23Service.setDataForIVI23(res);
      return this.isCurrentPath(state.url, '/ivi/my23') ? true : this.router.createUrlTree(['/ivi/my23']);
    }
    if (res) {
      let body = {
        access_token: res.accessToken ? res.accessToken : sessionState.getItem("accessToken"),
        client_reg_key: res.regKey ? res.regKey : sessionState.getItem("regKey")
      }
      
      let validateTokenRes = await this._appService.ValidateToken(body).toPromise().catch(() => null);
      
      
      if (validateTokenRes && validateTokenRes.request_status === "success") {
        if (validateTokenRes.user && validateTokenRes.user.first_name) {
          sessionState.setItem("first_name", validateTokenRes.user.first_name)
        }
        if (validateTokenRes.user && validateTokenRes.user.last_name) {
          sessionState.setItem("last_name", validateTokenRes.user.last_name)
        }
        if (validateTokenRes.user && validateTokenRes.user.email && validateTokenRes.user.email.length > 0) {
          sessionState.setItem("email", validateTokenRes.user.email[0])
        }
        if (validateTokenRes.user && validateTokenRes.user.country_code) {
          sessionState.setItem("countryCode", validateTokenRes.user.country_code);
        }

        if (res.vin) {
          sessionState.setItem("currentVinLocal", res.vin)
        }
        sessionState.setItem("userId", validateTokenRes.user.hidas_ident)
        if (res.accessToken) {
          sessionState.setItem("accessToken", res.accessToken)
        }
        if (res.regKey) {
          sessionState.setItem("regKey", res.regKey)
        }
        if(res.promoName){
          sessionState.setItem("promoName", res.promoName)
        }
         if(res.promoName){
          sessionState.setItem("promoName", res.promoName)
        }
        if (res.systemType) {
          //need to comment the line below before commit/build
          // res.programName = 'gdo_myq'
          if (res.programName) {
            sessionState.setItem("programName", res.programName);
            //for gdo, we'll have systemid from response
            let systemType = res.systemType;
            systemType = systemType.split("_");
            if (systemType && systemType.length > 1) {
              systemType = systemType[1];
            }
            else {
              systemType = "web";
            }
            
            sessionState.setItem("systemType", systemType);

            //getting vehicle make from system id
            let vehicleMake = res.systemType;
            if (vehicleMake) {
              const splitString = vehicleMake.split(".");
              vehicleMake = splitString.slice(1, 2).join(".");
              
              sessionState.setItem("vehicleMake", vehicleMake);
            }
          }
          else {
            //using system type from response for SSP
            sessionState.setItem("systemType", res.systemType);
          }
        }
        if (res.planType) {
          sessionState.setItem("planType", res.planType)
        }

        this._appService.setUserUpdated(!this._appService.getIsUserUpdated())

        //#region uncomment for Testing locally

        // sessionState.setItem("userId", "HondaAizazTestGDO26"); //GDO HIDAS FOR TESTING acura DARK MODE
        // sessionState.setItem("currentVinLocal", "19UYA31581L000026");
   
        // sessionState.setItem("userId", "USA0016a8b2ccb55c049438da2a9c3b115a0c0") //HONDA LIGHT MODE
        // sessionState.setItem("currentVinLocal", "1HGCY2F76TA058796");

        // sessionState.setItem("programName", "gdo_myq"); //if not uncommented, will throw invalid client id error
        // let programName = sessionState.getItem("programName")

        //#endregion 

        // comment the line below incase of testing otherwise program name will be null/overwritten.
        let programName = res.programName ? res.programName : sessionState.getItem("programName")
        let planType = res.planType ? res.planType : sessionState.getItem("planType")
        // 
        let systemType = sessionState.getItem("systemType")

        if ((route.routeConfig?.path === 'gdoWV' || route.data?.['routePurpose'] === 'gdo-webview-refresh-alias') &&
          (res.programName?.toLowerCase() !== 'gdo_myq' || !res.systemType ||
           (systemType !== 'android' && systemType !== 'ios'))) {
          return this.router.createUrlTree(['/not-found']);
        }

        if (this.isRefreshAlias(route)) {
          return true;
        }

        if (planType && planType.toLowerCase() == 'earlybird') {
          this.navigateIfNotCurrent('/subscriptionWV', state);
          this._appService.setViewViewStatus(true)
          this._appService.setLeftMenuVisibilityStatus(false)
        }
        else if (programName && programName.toLowerCase() == 'gdo_myq') {

          // GDO Webviews
          if ((systemType && (systemType == "android" || systemType == "ios"))) {
            this.navigateIfNotCurrent('/gdoWV', state);
            this._appService.setViewViewStatus(true)
            this._appService.setLeftMenuVisibilityStatus(false)
          }

          //GDO desktop
          if (systemType && systemType == 'web') {
            this.navigateIfNotCurrent('/gdo', state);
            this._appService.setViewViewStatus(false)
            this._appService.setLeftMenuVisibilityStatus(true)
          }
        }

        // SSP
        else {
          if ((systemType && (systemType == "android" || systemType == "ios"))) {
            this.navigateIfNotCurrent('/subscriptionWV', state);
            this._appService.setViewViewStatus(true)
            this._appService.setLeftMenuVisibilityStatus(false)
          }

          if ((systemType && systemType == "web")) {
            this._appService.setViewViewStatus(false)
            this._appService.setLeftMenuVisibilityStatus(true)
          }
        }

        return true
      } else {
        this._appService.setViewViewStatus(true)
        this._appService.setLeftMenuVisibilityStatus(false)
        this.router.navigate(['/not-found']);
        return false
      }
    } else {
      this._appService.setViewViewStatus(true)
      this._appService.setLeftMenuVisibilityStatus(false)
      this.router.navigate(['/not-found']);
      return false
    }
  }

  private navigateIfNotCurrent(targetPath: string, state: RouterStateSnapshot): void {
    if (!this.isCurrentPath(state.url, targetPath)) {
      this.router.navigate([targetPath]);
    }
  }

  private isCurrentPath(currentUrl: string, targetPath: string): boolean {
    const path = currentUrl.split('?')[0].split('#')[0];
    return path === targetPath || path.startsWith(targetPath + '/');
  }

  private isRefreshAlias(route: ActivatedRouteSnapshot): boolean {
    const routePurpose = route.data && route.data['routePurpose'];
    return typeof routePurpose === 'string' && routePurpose.indexOf('refresh-alias') >= 0;
  }
}

